import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { Payroll } from './payroll.model';
import { PayrollCounts } from './payroll-counts.model';
import { PayGroup } from '../shared/models/pay-group.model';
import { Product, Products } from './product.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Moment, utc } from 'moment';
import urlJoin from 'url-join';
import { map } from 'rxjs/operators';
import { SettingsService } from '../shared/services/settings/settings.service';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class PayrollService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService) {
  }

  getPayrolls(product: Product, payDate: Date, paySequences: number[], payGroups: PayGroup[]): Observable<Payroll[]> {
    if (product !== Products.EmployeePay) {
      return of(null);
    }
    const payMoment = utc(payDate);
    return this.http.get<Payroll[]>(this._getUri('byPayDay', this._getQueryParameters(payMoment, paySequences, payGroups)));
  }

  getPayrollCounts(product: Product, payDate: Date, paySequences: number[], payGroups: PayGroup[]): Observable<PayrollCounts> {
    if (product !== Products.EmployeePay) {
      return of(null);
    }

    const payMoment = utc(payDate);
    // Take only the first result, since we only request a single days' worth.
    return this.http.get<PayrollCounts[]>(this._getUri('countsByPayDay', this._getQueryParameters(payMoment, paySequences, payGroups)))
      .pipe(map(counts => counts && counts.length ? counts[0] : null));
  }

  private _getUri(path: string, params: string) {
    let url = urlJoin(this._getBaseUrl(), `payment/v1/tenants/${encodeURI(this.settings.tenantId)}/payrollinstances`);
    url = urlJoin(url, path);
    if (params) {
      url += '?' + params;
    }
    return url;
  }

  private _getBaseUrl(): string {
    return ROUTE_TOKEN_GATEWAY_URL;
  }

  private _getQueryParameters(payDate: Moment, paySequences: number[], payGroups: PayGroup[]): string {
    return new HttpParams()
      .append('fromDate', payDate.startOf('day').toISOString())
      .append('toDate', payDate.endOf('day').toISOString())
      .append('payGroups', (payGroups || []).map(group => group.code).join(','))
      .append('paySequences', (paySequences || []).join(','))
      .toString();
  }
}
